import Icon from '@ant-design/icons';

import { ReactComponent as PieChartSVG } from '../svg/pie-chart.svg';
import { ReactComponent as InboxSVG } from '../svg/inbox.svg';
import { ReactComponent as LayoutSVG } from '../svg/layout.svg';
import { ReactComponent as PeopleSVG } from '../svg/people.svg';
import { ReactComponent as LogSVG } from '../svg/log.svg';
import { ReactComponent as SettingSVG } from '../svg/setting.svg';
import { ReactComponent as ArrowHeadLeftSVG } from '../svg/arrow-head-left.svg';
import { ReactComponent as UploadSVG } from '../svg/upload.svg';
import { ReactComponent as DownloadSVG } from '../svg/download.svg';
import { ReactComponent as CodeDownloadSVG } from '../svg/code-download.svg';
import { ReactComponent as InfoSVG } from '../svg/info.svg';
import { ReactComponent as CloseSVG } from '../svg/close.svg';
import { ReactComponent as PlusSVG } from '../svg/plus.svg';
import { ReactComponent as BoldSVG } from '../svg/bold.svg';
import { ReactComponent as CodeSVG } from '../svg/code.svg';
import { ReactComponent as AlignLeft } from '../svg/align-left.svg';
import { ReactComponent as AlignCenter } from '../svg/align-center.svg';
import { ReactComponent as AlignRight } from '../svg/align-right.svg';
import { ReactComponent as HomeSVG } from '../svg/home.svg';
import { ReactComponent as MarkerSVG } from '../svg/marker.svg';
import { ReactComponent as FootPrintSVG } from '../svg/footprint.svg';

export const PieChartIcon = (props) => (
  <Icon component={PieChartSVG} {...props} />
);

export const InboxIcon = (props) => <Icon component={InboxSVG} {...props} />;

export const LayoutIcon = (props) => <Icon component={LayoutSVG} {...props} />;

export const PeopleIcon = (props) => <Icon component={PeopleSVG} {...props} />;

export const LogIcon = (props) => <Icon component={LogSVG} {...props} />;

export const SettingIcon = (props) => (
  <Icon component={SettingSVG} {...props} />
);

export const ArrowHeadLeftIcon = (props) => (
  <Icon component={ArrowHeadLeftSVG} {...props} />
);

export const UploadIcon = (props) => <Icon component={UploadSVG} {...props} />;

export const DownloadIcon = (props) => (
  <Icon component={DownloadSVG} {...props} />
);

export const CodeDownloadIcon = (props) => (
  <Icon component={CodeDownloadSVG} {...props} />
);

export const InfoIcon = (props) => <Icon component={InfoSVG} {...props} />;

export const CloseIcon = (props) => <Icon component={CloseSVG} {...props} />;

export const PlusIcon = (props) => <Icon component={PlusSVG} {...props} />;

export const BoldIcon = (props) => <Icon component={BoldSVG} {...props} />;

export const CodeIcon = (props) => <Icon component={CodeSVG} {...props} />;

export const AlignLeftIcon = (props) => (
  <Icon component={AlignLeft} {...props} />
);

export const AlignCenterIcon = (props) => (
  <Icon component={AlignCenter} {...props} />
);

export const AlignRightIcon = (props) => (
  <Icon component={AlignRight} {...props} />
);

export const HomeIcon = (props) => <Icon component={HomeSVG} {...props} />;

export const MarkerIcon = (props) => <Icon component={MarkerSVG} {...props} />;

export const FootPrintIcon = (props) => (
  <Icon component={FootPrintSVG} {...props} />
);
